import React, { Component } from 'react';
import { apiCall } from '../../helpers/api';
import Topbar from '../../components/topbar/Topbar';
import AdminNav from '../../components/adminnav/AdminNav';
import { Button, Col, Container, Modal, Row, Table, Form } from 'react-bootstrap';
import AlertModal from "../../components/alerts/alert";
import makeAnimated from 'react-select/animated';
import Select from 'react-select';

const audienceOptions = [
    { value: 'brands', label: 'Brands' },
    { value: 'influencers', label: 'Members' },
    { value: 'admins', label: 'Admins' },
    { value: 'agencies', label: 'Agencies' }
];
const animatedComponents = makeAnimated();

export class Announcements extends Component {
    constructor(props) {
        super(props);
        this.state = {
            announcements: [],
            newAnnouncement: false,
            newAnnouncementDetails: { title: '', description: '', releaseDate: '', audience: [] },
            editAnnouncement: null,
            alert: { display: 'toast', visible: false, title: '', content: '' },
            counter: 0
        };
    }

    componentDidMount() {
        this.loadAnnouncements();
    }

    async loadAnnouncements() {
        // Updated to use the new admin/announcements endpoint
        const response = await apiCall('admin/announcements', { method: 'GET', params: {} });
        const data = response && response.success;
        if (data && Array.isArray(data.announcements)) {
            this.setState({ announcements: data.announcements });
        } else {
            this.setState({ announcements: [] });
        }
    }

    validateAnnouncementFields(details) {
        if (!details.title || !details.title.trim()) return 'Title is required.';
        if (!details.description || !details.description.trim()) return 'Description is required.';
        if (!details.releaseDate) return 'Release date & time is required.';
        if (!details.audience || !details.audience.length) return 'At least one audience is required.';
        return null;
    }

    async createAnnouncement() {
        const error = this.validateAnnouncementFields(this.state.newAnnouncementDetails);
        if (error) {
            this.setState({ alert: { display: 'toast', visible: true, title: 'Validation Error', content: error, className: 'bg-danger text-background' } });
            return;
        }
        try {
            const response = await apiCall('admin/announcement', { method: 'POST', data: this.state.newAnnouncementDetails });
            const data = response && response.success;
            if (data && data.success) {
                this.setState({ newAnnouncement: false, newAnnouncementDetails: { title: '', description: '', releaseDate: '', audience: [] }, counter: this.state.counter + 1 });
                this.loadAnnouncements();
                this.setState({ alert: { display: 'toast', visible: true, title: 'Announcement Created', content: 'Announcement successfully created', className: 'bg-success text-background' } });
            } else {
                this.setState({ alert: { display: 'toast', visible: true, title: 'Failed to Create Announcement', content: (data && data.error) || 'Unknown error', className: 'bg-danger text-background' } });
            }
        } catch (err) {
            this.setState({ alert: { display: 'toast', visible: true, title: 'Network Error', content: err.message || 'An error occurred while creating the announcement.', className: 'bg-danger text-background' } });
        }
    }

    async updateAnnouncement() {
        const error = this.validateAnnouncementFields(this.state.editAnnouncement);
        if (error) {
            this.setState({ alert: { display: 'toast', visible: true, title: 'Validation Error', content: error, className: 'bg-danger text-background' } });
            return;
        }
        try {
            const response = await apiCall(`admin/announcement?id=${this.state.editAnnouncement._id}`, { method: 'PUT', data: this.state.editAnnouncement });
            const data = response && response.success;
            if (data && data.success) {
                this.setState({ editAnnouncement: null, counter: this.state.counter + 1 });
                this.loadAnnouncements();
                this.setState({ alert: { display: 'toast', visible: true, title: 'Announcement Updated', content: 'Announcement successfully updated', className: 'bg-success text-background' } });
            } else {
                this.setState({ alert: { display: 'toast', visible: true, title: 'Failed to Update Announcement', content: (data && data.error) || 'Unknown error', className: 'bg-danger text-background' } });
            }
        } catch (err) {
            this.setState({ alert: { display: 'toast', visible: true, title: 'Network Error', content: err.message || 'An error occurred while updating the announcement.', className: 'bg-danger text-background' } });
        }
    }

    async deleteAnnouncement(announcementId) {
        if (!window.confirm('Are you sure you want to delete this announcement?')) return;
        try {
            const response = await apiCall(`admin/announcement?id=${announcementId}`, { method: 'DELETE' });
            const data = response && response.success;
            if (data && data.success) {
                this.setState({ counter: this.state.counter + 1 });
                this.loadAnnouncements();
                this.setState({ alert: { display: 'toast', visible: true, title: 'Announcement Deleted', content: 'Announcement successfully deleted', className: 'bg-success text-background' } });
            } else {
                this.setState({ alert: { display: 'toast', visible: true, title: 'Failed to Delete Announcement', content: (data && data.error) || 'Unknown error', className: 'bg-danger text-background' } });
            }
        } catch (err) {
            this.setState({ alert: { display: 'toast', visible: true, title: 'Network Error', content: err.message || 'An error occurred while deleting the announcement.', className: 'bg-danger text-background' } });
        }
    }

    render() {
        return (
            <div className="bg-page influencers">
                <Topbar />
                <div className="pageName">Announcements</div>
                <Container id="applicant-list-container" className="fullscreenWithTopBar top-0" fluid>
                    <Row>
                        <AdminNav />
                        <div className="col-xl-12 col-xxl-10 px-0">
                            <div className="px-4 py-3 py-xl-4 bg-background shadow-sm">
                                <div className="d-flex align-items-center justify-content-between mx-xl-4">
                                <h1 className="pageTitle text-nowrap text-primary secondaryHeadingsFont fw-700 mb-0 fs-3">Announcements</h1>
                                <button type='submit' className="link btn btn-sm btn-primary" onClick={() => this.setState({newAnnouncement: true})}>Create</button>
                                </div>
                            </div>     
                            <div className="p-4 pt-0 influencersTable mt-2 mt-xl-4 pb-0">
                                <div className="mx-xl-4">
                                    <AlertModal modal={this.state.alert} onClose={() => this.setState({ alert: { display: 'toast', visible: false, title: '', content: '' } })} />
                                    <div className="tableHeaderFixedBelt"></div>
                                    <Table className="border-transparent">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>Description</th>
                                                <th>Release Date</th>
                                                <th>Audience</th>
                                                <th>Read Count</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.announcements.map((announcement, idx) => (
                                                <tr key={announcement._id}>
                                                    <td>{announcement.title}</td>
                                                    <td>{announcement.description}</td>
                                                    <td>{new Date(announcement.releaseDate * 1000).toLocaleString()}</td>
                                                    <td>{Array.isArray(announcement.audience) ? announcement.audience.join(', ') : ''}</td>
                                                    <td>{announcement.readCount || 0}</td>
                                                    <td>
                                                        <div className="d-flex gap-2">
                                                            <Button size="sm" onClick={() => this.setState({ editAnnouncement: { ...announcement } })}>Edit</Button>
                                                            <Button size="sm" variant="danger" onClick={() => this.deleteAnnouncement(announcement._id)}>Delete</Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                            {/* New Announcement Modal */}
                            {this.state.newAnnouncement && (
                                <Modal show={this.state.newAnnouncement} onHide={() => this.setState({ newAnnouncement: false })} centered>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Add New Announcement</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Form>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Title</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={this.state.newAnnouncementDetails.title}
                                                    onChange={e =>
                                                        this.setState({
                                                            newAnnouncementDetails: {
                                                                ...this.state.newAnnouncementDetails,
                                                                title: e.target.value
                                                            }
                                                        })
                                                    }
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Description</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    value={this.state.newAnnouncementDetails.description}
                                                    onChange={e =>
                                                        this.setState({
                                                            newAnnouncementDetails: {
                                                                ...this.state.newAnnouncementDetails,
                                                                description: e.target.value
                                                            }
                                                        })
                                                    }
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Release Date & Time</Form.Label>
                                                <Form.Control
                                                    type="datetime-local"
                                                    value={
                                                        this.state.newAnnouncementDetails.releaseDate
                                                            ? new Date(this.state.newAnnouncementDetails.releaseDate * 1000)
                                                                .toISOString()
                                                                .slice(0, 16)
                                                            : ''
                                                    }
                                                    onChange={e => {
                                                        const date = e.target.value
                                                            ? Math.floor(new Date(e.target.value).getTime() / 1000)
                                                            : '';
                                                        this.setState({
                                                            newAnnouncementDetails: {
                                                                ...this.state.newAnnouncementDetails,
                                                                releaseDate: date
                                                            }
                                                        });
                                                    }}
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Audience</Form.Label>
                                                <Select
                                                    isMulti
                                                    closeMenuOnSelect={false}
                                                    components={animatedComponents}
                                                    options={audienceOptions}
                                                    value={audienceOptions.filter(opt =>
                                                        (this.state.newAnnouncementDetails.audience || []).includes(opt.value)
                                                    )}
                                                    onChange={selected =>
                                                        this.setState({
                                                            newAnnouncementDetails: {
                                                                ...this.state.newAnnouncementDetails,
                                                                audience: selected.map(opt => opt.value)
                                                            }
                                                        })
                                                    }
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => this.setState({ newAnnouncement: false })}>
                                            Cancel
                                        </Button>
                                        <Button variant="primary" onClick={() => this.createAnnouncement()}>
                                            Create
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            )}
                            {/* Edit Announcement Modal */}
                            {this.state.editAnnouncement && (
                                <Modal show onHide={() => this.setState({ editAnnouncement: null })} centered>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Edit Announcement</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Form>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Title</Form.Label>
                                                <Form.Control type="text" value={this.state.editAnnouncement.title} onChange={e => this.setState({ editAnnouncement: { ...this.state.editAnnouncement, title: e.target.value } })} />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Description</Form.Label>
                                                <Form.Control as="textarea" rows={3} value={this.state.editAnnouncement.description} onChange={e => this.setState({ editAnnouncement: { ...this.state.editAnnouncement, description: e.target.value } })} />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Release Date & Time</Form.Label>
                                                <Form.Control
                                                    type="datetime-local"
                                                    value={this.state.editAnnouncement.releaseDate ? new Date(this.state.editAnnouncement.releaseDate * 1000).toISOString().slice(0, 16) : ''}
                                                    onChange={e => {
                                                        const date = e.target.value ? Math.floor(new Date(e.target.value).getTime() / 1000) : '';
                                                        this.setState({ editAnnouncement: { ...this.state.editAnnouncement, releaseDate: date } });
                                                    }}
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Audience</Form.Label>
                                                <Select
                                                    isMulti
                                                    closeMenuOnSelect={false}
                                                    components={animatedComponents}
                                                    options={audienceOptions}
                                                    value={audienceOptions.filter(opt => (this.state.editAnnouncement.audience || []).includes(opt.value))}
                                                    onChange={selected => this.setState({ editAnnouncement: { ...this.state.editAnnouncement, audience: selected.map(opt => opt.value) } })}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => this.setState({ editAnnouncement: null })}>Cancel</Button>
                                        <Button variant="primary" onClick={() => this.updateAnnouncement()}>Save</Button>
                                    </Modal.Footer>
                                </Modal>
                            )}
                        </div>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Announcements;
